export enum TableDensity {
    Compact = 0,
    Standard = 1,
    Comfortable = 2
}

export const tableDensities: Map<string, TableDensity> = new Map<string, TableDensity>([
    ['compact', TableDensity.Compact],
    ['standard', TableDensity.Standard],
    ['comfortable', TableDensity.Comfortable]
]);

import type { VehicleIdentifierPlateSize } from '@/constants/vehicle-identifier-plate-size';

export const tableDensitiesToSizing = new Map<DensitySize, VehicleIdentifierPlateSize>([
    ['compact', 'small'],
    ['standard', 'medium'],
    ['comfortable', 'large']
]);

export function mapTableDensity(density: DensitySize): TableDensity;
export function mapTableDensity(density: TableDensity): DensitySize;
export function mapTableDensity(density: DensitySize | TableDensity): DensitySize | TableDensity {
    if (typeof density === 'string') {
        return tableDensities.get(density) ?? TableDensity.Standard;
    }

    switch (density) {
        case TableDensity.Compact:
            return 'compact';
        case TableDensity.Standard:
            return 'standard';
        case TableDensity.Comfortable:
            return 'comfortable';
    }
}

export type DensitySize = 'comfortable' | 'standard' | 'compact';